import HomeIcon from "@mui/icons-material/Home";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { Outlet, Link, useLocation } from "react-router-dom";
import translateText, { currentLanguage } from "../signals/language.signal";
import { primary } from "../signals/Theme colors.signal";
import { signalPagePath } from "../signals/login.signal";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
const AppBar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path
      ? { fill: primary.value, color: primary.value }
      : {};
  };
  return (
    <>
      <nav
        className="position-fixed bottom-0 align-items-center bg-white d-flex justify-content-between Contaner p-3 p-md-4  rounded-top-4 shadow w-100"
        style={{
          height: "70px",
          maxWidth: "900px",
          left: "50%",
          transform: "translate(-50%, 0%)",
        }}
      >
        <Link
          to={signalPagePath.value ? "/home" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center flex-column align-items-center">
            <HomeIcon
              style={isActive("/home")}
              sx={{
                cursor: "pointer",
                fill: "#cdcdcd",
                fontSize: 28,
              }}
            />
            <p
              style={{
                color: "#cdcdcd",
                cursor: "pointer",
                fontSize: "9px",
                margin: "0",
                ...isActive("/home"),
              }}
            >
              {translateText(currentLanguage.value, "HomeTitle")}
            </p>
          </div>
        </Link>

        <Link
          to={signalPagePath.value ? "/myOrder" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center flex-column align-items-center">
            <ReceiptLongIcon
              style={isActive("/myOrder")}
              sx={{
                cursor: "pointer",
                fill: "#cdcdcd",
                fontSize: 28,
              }}
            />
            <p
              style={{
                cursor: "pointer",
                color: "#cdcdcd",
                fontSize: "9px",
                margin: "0",
                ...isActive("/myOrder"),
              }}
            >
              {translateText(currentLanguage.value, "MyOrderTitle")}
            </p>
          </div>
        </Link>
        <Link
          to={signalPagePath.value ? "/product" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center flex-column align-items-center">
            <svg
              width="30"
              height="30"
              viewBox="0 0 42 45"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                cursor: "pointer",
                fill: "#cdcdcd",
                fontSize: 8,

                ...isActive("/product"),
              }}
            >
              <path d="M19.6667 15.0053C22.0518 12.3447 24.4358 9.68192 26.8188 7.01686C27.4815 6.25015 28.2945 5.64677 29.2007 5.24915C27.8742 5.5078 26.6674 6.22982 25.7725 7.30023C23.4553 9.89557 21.1338 12.4887 18.808 15.0795L12.2347 22.4C12.1361 22.8082 12.0312 23.213 11.9358 23.6212C14.5117 20.747 17.0887 17.875 19.6667 15.0053Z" />
              <path d="M5.82007 35.9594C5.84855 36.0266 5.88179 36.0915 5.91502 36.1542C5.89366 36.0892 5.87229 36.0243 5.8533 35.9572L5.82007 35.9594Z" />
              <path d="M0.275085 7.4585C0.307573 15.6118 0.300076 23.7674 0.305074 31.9296C0.300076 23.7696 0.307573 15.6051 0.275085 7.43835V7.4585Z" />
              <path d="M0.398167 32.7378L0.322205 32.2476C0.336358 32.4123 0.361731 32.5761 0.398167 32.7378Z" />
              <path d="M32.0962 5.77451C34.7046 6.38524 36.1436 7.9603 36.6758 10.1256C37.0574 11.689 36.4867 13.077 35.3769 14.3307C34.5051 15.3154 33.6376 16.3236 32.6853 17.3902C35.6853 18.3902 37.8 18.4998 40.3 17.9998C38.3 17.9622 36.0089 17.9588 34.0184 17.3902C34.9952 16.2944 35.8985 15.2891 36.7948 14.2751C37.9327 12.9894 38.5174 11.5634 38.1253 9.95908C37.5826 7.73529 36.1016 6.11932 33.4232 5.49105C32.0401 5.13321 30.5532 5.17334 29.2007 5.60502C30.1691 5.48352 31.1577 5.54138 32.0962 5.77451Z" />
              <path d="M0.305603 32.1534L0.323626 32.2564C0.323626 32.1534 0.305603 32.0505 0.305603 31.943V32.1534Z" />
              <path d="M2.42687 1.66935C6.57997 0.237504 10.7679 0.245329 14.9017 1.73195C16.5056 2.30312 16.9124 3.23421 16.893 4.42612C16.8116 8.62256 16.862 12.819 17.0789 17.0598C17.2184 16.7468 17.354 16.4338 17.4935 16.1209C17.2804 12.0313 17.2494 7.98096 17.3308 3.92275C17.354 2.69955 16.9433 1.74238 15.293 1.15556C11.0314 -0.370184 6.74656 -0.378008 2.48498 1.09035C1.77957 1.30859 1.18782 1.66448 0.786467 2.11185C0.385114 2.55923 0.192673 3.07746 0.234097 3.59935V4.07924C0.201404 3.5762 0.392666 3.07805 0.783355 2.64867C1.17404 2.2193 1.74635 1.87828 2.42687 1.66935Z" />
              <path d="M14.8527 3.61108C11.9498 2.70847 5.57417 2.71824 2.71992 3.63061C1.47837 4.02135 1.39442 4.38474 2.71992 4.6563C4.62864 5.04704 6.69643 5.26194 8.77746 5.56477C10.9292 5.25999 12.9616 5.05681 14.8217 4.68365C16.2798 4.3906 16.1826 4.02721 14.8527 3.61108Z" />
              <path d="M13.1709 37.0159C14.1693 37.2703 15.1968 37.4094 16.2307 37.4301C19.5541 37.5196 22.8584 37.6136 26.1675 37.5509C27.9407 37.5151 29.4244 36.8659 30.2647 35.1354C31.105 33.4049 32.1946 31.8132 33.1774 30.1588L39.3198 19.0146C39.3198 19.0146 37.1758 19.2747 35.8198 19.0146C34.2385 18.7114 33.4254 17.8929 31.8198 18.0146C29.5497 18.1868 26.8125 21 26.8125 21C26.8125 21 19.9908 29.2051 17.0188 32.7825C14.975 35.2182 11.1531 34.8847 9.96623 32.1311C9.70671 31.5787 9.62328 30.9671 9.72614 30.3708C9.82899 29.7745 10.1137 29.2193 10.5454 28.773C11.4238 27.7835 12.5988 27.6044 13.8688 27.8664C15.1388 28.1283 15.9221 29.2745 15.8794 30.5909C15.8462 31.6565 14.9607 32.6684 13.8284 32.7848C13.4724 32.8228 12.8623 32.6325 12.7507 32.3908C12.5133 31.8759 13.0023 31.7192 13.4937 31.6296C14.1418 31.5244 14.6806 31.1393 14.5667 30.5103C14.4717 30.0021 14.1275 29.3596 13.6836 29.1178C12.6558 28.5604 11.3312 29.2678 11.0724 30.3715C10.9938 30.6988 10.9919 31.0383 11.0669 31.3663C11.1418 31.6944 11.2918 32.0031 11.5063 32.2708C11.7208 32.5386 11.9947 32.7589 12.3089 32.9165C12.623 33.0741 12.9699 33.1652 13.3252 33.1833C15.756 33.3265 17.3607 30.9916 16.3589 28.7327C15.6468 27.0963 13.8735 26.2277 11.7632 26.4694C9.7882 26.6933 8.0933 28.2604 7.85117 30.0513C7.46661 32.8049 10.0018 36.1742 13.1709 37.0159Z" />
              <path d="M8.02589 35.0913C5.67159 31.1545 6.5261 28.5299 8.81066 25.2492C8.95598 24.9589 15.8551 17.6799 15.8736 17.3754C15.8736 11.8881 15.8829 11.6161 15.8829 6.12695C15.87 5.96679 15.843 5.80723 15.802 5.649C8.93127 6.75426 7.7819 6.75154 2.35429 5.56482C2.32449 5.94772 2.26915 6.2926 2.26915 6.63748C2.26915 15.4125 2.26915 24.1866 2.26915 32.9599C2.26915 35.1676 3.12054 35.8303 6.5261 36.2376C6.84111 36.2729 7.26255 36.2132 7.45411 36.3245C7.83724 36.5472 8.3651 36.8676 8.32678 37.1392C8.28847 37.4107 7.59459 37.704 7.16038 37.7257C5.56822 37.8161 3.97934 37.5311 2.69439 36.9246C1.40944 36.3181 0.517559 35.4322 0.1875 34.4344L0.391834 35.355C0.391834 37.0224 4.12092 38.3721 8.71842 38.3721C9.12283 38.3721 9.51447 38.3585 9.8976 38.3368C9.45999 37.5966 7.60751 35.836 8.02589 35.0913Z" />
              <path d="M39.8059 18.0019L39.2772 18.0262C40.4383 18.2963 40.8684 19.3956 40.1727 20.7272C37.3395 26.1668 34.5164 31.6119 31.6098 37.0057C30.77 38.5614 29.1257 38.8558 27.618 39.1961C26.8739 39.348 26.1159 39.407 25.359 39.3717C21.8597 39.2745 18.3611 39.152 14.8635 39.0044C12.4072 38.9044 10.4467 37.7755 8.8125 36.0009C10.5833 38.1239 12.7259 39.4987 15.4832 39.6121C19.0753 39.7579 22.6675 39.884 26.2596 39.9902C27.0369 40.0253 27.8153 39.9636 28.5793 39.8066C30.1249 39.4581 31.8147 39.1556 32.6748 37.5594C35.6598 32.0198 38.5588 26.4288 41.4679 20.846C42.3154 19.2227 41.5388 17.9398 39.8059 18.0019Z" />
              <path d="M18.9875 28.5L26.4875 20.5C26.4875 20.5 31.1545 16.833 33.9875 14C35.4875 12.5 36.117 9.207 34.2247 7.53035C32.4544 5.96183 29.9461 6.28542 28.1888 8.02832C23.061 13.1367 17.9387 18.2481 12.8219 23.3627C12.6186 23.5681 12.4514 23.8047 12.2219 24.0817C17.0709 24.1159 18.9875 28.5 18.9875 28.5Z" />
            </svg>

            <p
              style={{
                cursor: "pointer",
                color: "#cdcdcd",
                fontSize: "9px",
                margin: "0",
                ...isActive("/product"),
              }}
            >
              {translateText(currentLanguage.value, "ProductTitle")}
            </p>
          </div>
        </Link>

        <Link
          to={signalPagePath.value ? "/offer" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center flex-column align-items-center">
            <LocalOfferIcon
              style={isActive("/offer")}
              sx={{
                cursor: "pointer",
                fill: "#cdcdcd",
                fontSize: 28,
              }}
            />
            <p
              style={{
                cursor: "pointer",
                color: "#cdcdcd",
                fontSize: "9px",
                margin: "0",
                ...isActive("/offer"),
              }}
            >
              {translateText(currentLanguage.value, "OfferTitle")}
            </p>
          </div>
        </Link>
        <Link
          to={signalPagePath.value ? "/coupon" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="position-relative d-flex justify-content-center flex-column align-items-center">
            <svg
              style={{ cursor: "pointer", fill: "#cdcdcd", fontSize: 28 }}
              width="28"
              height="27"
              viewBox="0 0 44 27"
              xmlns="http://www.w3.org/2000/svg"
              className="me-3 ms-3"
            >
              <path
                d="M0 5C0 2.23858 2.23858 0 5 0H39C41.7614 0 44 2.23858 44 5V9.25V9.25C39.7158 10.4638 39.7158 16.5362 44 17.75V17.75V22C44 24.7614 41.7614 27 39 27H5C2.23858 27 0 24.7614 0 22V17.75V17.75C4.28417 16.5362 4.28417 10.4638 0 9.25V9.25V5Z"
                fill="#cdcdcd"
                {...isActive("/coupon")}
              />
            </svg>
            <p
              style={{
                cursor: "pointer",
                color: "#cdcdcd",
                fontSize: "9px",
                margin: "0",
                ...isActive("/coupon"),
              }}
            >
              {translateText(currentLanguage.value, "Coupon")}
            </p>
          </div>
        </Link>

        {/* <Link
          to={signalPagePath.value ? "/noteRate" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center flex-column align-items-center">
            <SpeakerNotesIcon
              style={isActive("/noteRate")}
              sx={{
                cursor: "pointer",
                fill: "#cdcdcd",
                fontSize: 28,
              }}
            />
            <p
              style={{
                cursor: "pointer",
                color: "#cdcdcd",
                fontSize: "9px",
                margin: "0",
                ...isActive("/noteRate"),
              }}
            >
              {translateText(currentLanguage.value, "NoteRateTitle")}
            </p>
          </div>
        </Link> */}
        <Link
          to={signalPagePath.value ? "/more" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center flex-column align-items-center">
            <MoreHorizIcon
              style={isActive("/more")}
              sx={{
                cursor: "pointer",
                fill: "#cdcdcd",
                fontSize: 28,
              }}
            />
            <p
              style={{
                cursor: "pointer",
                color: "#cdcdcd",
                fontSize: "9px",
                margin: "0",
                ...isActive("/more"),
              }}
            >
              {translateText(currentLanguage.value, "More")}
            </p>
          </div>
        </Link>
      </nav>
      <Outlet />
    </>
  );
};

export default AppBar;
